import type { FC, ReactNode } from 'react'
import type { RegisterUpdater } from '@/components/landing/film/overlay-utils'

import SceneOpener from '@/components/landing/film/scenes/scene-opener'
import SceneEngineering from '@/components/landing/film/scenes/scene-engineering'
import SceneKinetics from '@/components/landing/film/scenes/scene-kinetics'
import SceneFinishes from '@/components/landing/film/scenes/scene-finishes'
import SceneFinale from '@/components/landing/film/scenes/scene-finale'
import FilmChrome from '@/components/landing/film/film-chrome'

interface FilmOverlayProps {
    register: RegisterUpdater
    onCta: () => void
}

// Every typographic and HUD layer of the film, each driven by the shared film clock
const FilmOverlay: FC<FilmOverlayProps> = ({ register, onCta }): ReactNode => {
    return (
        <div className='absolute inset-0 select-none'>
            <SceneOpener register={register} />
            <SceneEngineering register={register} />
            <SceneKinetics register={register} />
            <SceneFinishes register={register} />
            <SceneFinale register={register} onCta={onCta} />
            <FilmChrome register={register} />
        </div>
    )
}

export default FilmOverlay
